// test849
(849 && 0);
